import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import LanguageRouter from "./components/LanguageRouter";
import HomePage from "./pages/HomePage";
import ComeFunzionaPage from "./pages/ComeFunzionaPage";
import TariffePage from "./pages/TariffePage";
import ListinoPage from "./pages/ListinoPage";
import ConfiguratorePage from "./pages/ConfiguratorePage";
import PerChiPage from "./pages/PerChiPage";
import ContattiPage from "./pages/ContattiPage";
import PrivacyPage from "./pages/PrivacyPage";
import TerminiPage from "./pages/TerminiPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageRouter />
        <Layout>
          <Routes>
            {/* Italian (canonical) */}
            <Route path="/" element={<HomePage />} />
            <Route path="/come-funziona" element={<ComeFunzionaPage />} />
            <Route path="/tariffe" element={<TariffePage />} />
            <Route path="/tariffe/listino" element={<ListinoPage />} />
            <Route path="/tariffe/configuratore" element={<ConfiguratorePage />} />
            <Route path="/per-chi" element={<PerChiPage />} />
            <Route path="/contatti" element={<ContattiPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/termini" element={<TerminiPage />} />

            {/* English (SEO-friendly translated slugs) */}
            <Route path="/en" element={<HomePage />} />
            <Route path="/en/how-it-works" element={<ComeFunzionaPage />} />
            <Route path="/en/pricing" element={<TariffePage />} />
            <Route path="/en/pricing/list" element={<ListinoPage />} />
            <Route path="/en/pricing/configurator" element={<ConfiguratorePage />} />
            <Route path="/en/who-its-for" element={<PerChiPage />} />
            <Route path="/en/contact" element={<ContattiPage />} />
            <Route path="/en/privacy" element={<PrivacyPage />} />
            <Route path="/en/terms" element={<TerminiPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
